import { render } from "./AddEditOnboarding.vue?vue&type=template&id=e464e47e&ts=true"
import script from "./AddEditOnboarding.vue?vue&type=script&lang=ts"
export * from "./AddEditOnboarding.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__